export default class Dropdown {
  constructor({ el, headEl, bodyEl }) {
    this.DOM = { el, headEl, bodyEl };
    this.state = {
      isOpen: false,
      contentHeight: 0
    };
  }

  init() {
    if (!this.DOM.el || !this.DOM.headEl || !this.DOM.bodyEl) return;
    this.bindEvents();
  }

  bindEvents() {
    this.DOM.headEl.forEach(el => el.addEventListener('click', this.onClick.bind(this)));
  }

  onClick(e) {
    e.preventDefault();
    this.state.contentHeight = this.DOM.bodyEl.scrollHeight;
    this.state.isOpen ? this.hideContent() : this.showContent();
  }

  showContent() {
    this.state.isOpen = true;
    this.DOM.el.classList.add('is-open');
    this.DOM.bodyEl.style.maxHeight = `${this.state.contentHeight}px`;
  }

  hideContent() {
    this.state.isOpen = false;
    this.DOM.el.classList.remove('is-open');
    this.DOM.bodyEl.style.maxHeight = `0px`;
  }
}